var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"outlined":_vm.outlined,"color":"primary","loading":_vm.api.isLoading}},[_vm._v(" Last Login: "+_vm._s(_vm.$moment(_vm.lastLogin).format("DD MMM YYYY hh:mm A"))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }